import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5485bb8c")

_pushScopeId("data-v-5485bb8c")
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Delete team")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Are you sure you want to delete this team? All conversations and files will be deleted, including any work uploaded by students or fellow lecturers.")
const _hoisted_6 = { style: {"margin-top":"10px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Confirm deletion")
const _hoisted_9 = { style: {"margin-top":"20px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h3", null, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _hoisted_4
              ], {}, true)
            ]),
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _hoisted_5
            ], {}, true),
            _createVNode("div", _hoisted_6, [
              _createVNode("label", null, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isConfirmed = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isConfirmed]
                ]),
                _hoisted_7,
                _renderSlot(_ctx.$slots, "confirm", {}, () => [
                  _hoisted_8
                ], {}, true)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("button", {
                class: "button-primary",
                disabled: !_ctx.isConfirmed,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm')))
              }, "Yes", 8, ["disabled"]),
              _createVNode("button", {
                class: "button-secondary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
              }, "No")
            ])
          ])
        ])
      ])
    ]),
    _: 3
  }))
})